<div>
	<div *ngIf="isAddOrganization">
	
		<div>
			<his-plam label="{{'fs.res.common.organizations.internal'|hisUi}}">
                <!-- #296767 hier brauchen wir das ngModel damit das Input-Feld nach einer Eingabe wieder gelöscht wird -->
				<p-autoComplete appendTo="body" #content 
                    [(ngModel)]="selectedOrganization"
				    [hisDdKey]="ddKey"
					[forceSelection]="true"
					field="text"
					[dropdown]="true" 
					[suggestions]="filteredOptions"
					(completeMethod)="completeMethod($event)"
					(onSelect)="onSelectByAutocomplete($event)">
				</p-autoComplete>
			</his-plam>
		</div>
		<div>
			<his-tree-select-popup
				treename="orgunit" 
				[showDeleteButton]="false"
				[tree]="orgunitTree" 
				[showSubtreeSelectColumn]="false"
				[singleSelect]="singleSelect"
				[selectedData]="selectedTreeElements" 
				(selectedDataChange)="onSelectByTree($event)"
				[title]="'fs.res.common.organizations.internal.assign' | hisUi"
				class="indentContent">
			</his-tree-select-popup>
		</div>
	</div>
	
	<ng-container *ngIf="showSelectionBelow">
		<div *ngIf="organizations.length > 0">
			<h4>{{ (organizations.length > 1 ? 'fs.res.common.organizations.internal.assignedInternalOrgUnit_plural' : 'fs.res.common.organizations.internal.assignedInternalOrgUnit') | hisUi }}</h4>
			
			<p-table [value]="organizations">
				<ng-template pTemplate="header">
					<tr>
						<th>{{ 'fs.res.common.organizations.internal.defaulttext' | hisUi }}</th>
				    	<th>{{'common.actions' | hisUi }}</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-internal>
					<tr>
				    	<td>{{internal.text}}</td>
				        <td class="singleLine">
							<button (click)="deleteOrganization(internal)" hisImage="DELETE" class="icon" 
                                title="{{'common.removeAssignmentOf' | hisUi:(internal.text)}}">
                            </button>		            
				        </td>
				    </tr>
				</ng-template>
			</p-table>
		</div>
	</ng-container>
	
</div>